import { VirtualAgentFilled } from "@aircall/icons";
import { Flex, Typography } from "@aircall/tractor";

type VirtualAgentProps = {
  name: string;
  bold?: boolean;
};

export function VirtualAgent({ name, bold = false }: VirtualAgentProps) {
  return (
    <Flex alignItems="center" gap="xxs">
      <VirtualAgentFilled color="primary-500" />
      <Typography
        variant={bold ? "headingBoldS" : "bodyMediumS"}
        color={bold ? "text-interactive-primary" : "text-base"}
      >
        {name}
      </Typography>
    </Flex>
  );
}
